import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlidesWide"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H18V8H22V20H6V16H2V4ZM6 14H4V6H16V8H6V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesWide;
